<ng-container *ngIf='templateData !== null'>
  <ng-container *ngIf='(templateData.root)'>
    <div #root [class]="templateData.templateClass + ' templateClass'" [style]="getRootStyle()">
      <ng-container *ngIf='(!templateData.grids) || templateData.grids.length === 0'>
        <div #zone class="app-zone-view" [zoneData]="templateData" (updateZone)="getFromZone($event)"
          [elementsToExclude]="existingElements" [style]="getRootStyle()" id="{{templateData.id}}"
          [componentDesigns]="designSelectionSet">
        </div>
      </ng-container>
      <ng-container *ngIf='templateData.grids && templateData.grids.length !== 0'>
        <ng-container *ngFor='let grid of templateData.grids'>
          <div #child class="app-template" [templateData]='grid' [align]="templateData.alignment"
            (updateZoneTemplate)="getFromZone($event)" [existingElements]="existingElements"
            [parentHeight]="selfheight" [parentWidth]="selfwidth" [style]="getStyle(grid.height, grid.width)"
            [elementDesigns]="designSelectionSet"></div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf='(!templateData.root)'>
    <ng-container *ngIf='(!templateData.grids) || templateData.grids.length === 0'>
      <div #zone class="app-zone-view" [zoneData]="templateData" (updateZone)="getFromZone($event)"
        [elementsToExclude]="existingElements" [style]="getRootStyle()" id="{{templateData.id}}"
        [componentDesigns]="designSelectionSet">
      </div>
    </ng-container>
    <ng-container *ngIf='templateData.grids && templateData.grids.length !== 0'>
      <ng-container *ngFor='let grid of templateData.grids'>
        <div #child class="app-template" [templateData]='grid' [align]="templateData.alignment"
          (updateZoneTemplate)="getFromZone($event)" [existingElements]="existingElements"
          [parentHeight]="selfheight" [parentWidth]="selfwidth" [style]="getStyle(grid.height, grid.width)"
          [elementDesigns]="designSelectionSet"></div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>